import { render, staticRenderFns } from "./RestaurantNotWorking.vue?vue&type=template&id=edacc5f0&scoped=true&"
import script from "./RestaurantNotWorking.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RestaurantNotWorking.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RestaurantNotWorking.vue?vue&type=style&index=0&id=edacc5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edacc5f0",
  null
  
)

export default component.exports